import { FullWidth } from 'ui/utility/fullWidth';

import { HeaderRow } from './HeaderRow';
import { ListsTableRows } from './ListsTableRows';
import { ListsNoResultsPlaceholder } from '../ListsNoResultsPlaceholder';
import { ListFolderRows } from '../folders/ListFolderRows';

export const ListsTable = () => (
  <>
    <FullWidth>
      <HeaderRow />
      <ListFolderRows />
      <ListsTableRows />
    </FullWidth>
    <ListsNoResultsPlaceholder />
  </>
);
